<template>
  <v-card>
    <!-- <v-card-title>
      <v-btn icon text @click="getCellsList" v-if="refresh">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer v-if="refresh"></v-spacer>
      <v-select
        v-model="selectedFilter"
        :items="cellFilters"
        filled
        outlined
        hide-details
        dense
        rounded
        class="mr-2"
        multiple
        style="max-width: 340px"
      ></v-select>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        clearable
        dense
        filled
        outlined
        rounded
        style="max-width: 400px"
      ></v-text-field>
    </v-card-title> -->
    <v-dialog
      v-model="groupCellsDialog"
      max-width="900px"
    >
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="groupCellsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Group Cells</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false" v-exporttocsv="'#groupcells'">
              <v-icon small>save</v-icon> Download
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-simple-table class="dialog-no-footer" id="groupcells">
          <template v-slot:default>
            <thead>
              <tr>
                <th>#</th>
                <th>Value</th>
                <th>Power</th>
                <th>Generation</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cell, i) in groupcells" :key="i">
                <td>{{cell.number}}</td>
                <td>{{cell.value}}</td>
                <td>{{cell.power}}</td>
                <td>{{cell.generation}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>
    <v-data-table 
      :headers="headers"
      :items="cellList"
      :loading="loading"
      :server-items-length="listCount"
      :options.sync="options"
    >
      <template v-slot:item.balancedon="{ item }">
        {{$date.utcToLocal(item.balancedon)}}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn text @click="viewItem(item)" class="mr-1">
          <v-icon small>remove_red_eye</v-icon> View
        </v-btn>
        <v-btn text @click="downloadItem(item)" color="blue">
          <v-icon small>save</v-icon> Download
        </v-btn>
        <v-btn text @click="deleteItem(item)" color="red" v-if="deleteButton">
          <v-icon small>delete</v-icon> Delete
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { balancedcells } from "@/api";
import XLSX from 'xlsx';

export default {
  name: "BalancedGroup",
  props: {
    refresh: {
      type: Boolean,
      default: function() {
        return true
      }
    },
    deleteButton: {
      type: Boolean,
      default: function() {
        return true
      }
    }
  },
  data: () => ({
    
    groupCellsDialog: false,
    loading: false,
    options: {},
    headers: [
			{ text: 'Balanced On', value: 'balancedon' },
			{ text: 'Actions', value: 'action', sortable: false },
    ],
    groupcells: [],
    cellList: [],
    listCount: 0,
  }),

  watch: {
    dialog (val) {
      val || this.close()
    },
    options: {
      handler () {
        this.getCellsList()
      },
      deep: true,
    },
		search() {
			this.getCellsList()
		}
  },
  methods: {
    initialize () {
      this.getCellsList()
    },
    async getCellsList() {
      const { page = 1, itemsPerPage = 10 } = this.options
      this.loading = true;
      const response = await balancedcells.group(itemsPerPage, page);
      this.listCount = response.data.count;
      this.cellList = response.data.data;
      this.loading = false;
    },
    async viewItem (item) {
      try {
        const response = await balancedcells.groupcells(item.balancedon);
        this.groupcells = response.data;
        this.groupCellsDialog = true;
      } catch (error) {
        this.$toast.error("Error Getting Battery")
      }
    },
    async downloadItem (item) {
      try {
        const response = await balancedcells.groupcells(item.balancedon);
        const colsNumber = [];
        const colsPower = [];
        const headers = [];
        const sortedNumber = this.$clone(response.data).sort((a, b) => a.number - b.number);
        const sortedPower = this.$clone(response.data).sort((a, b) => a.power - b.power);
        // String.fromCharCode(97) - String.fromCharCode(97 + 25);
        // A - Z
        let key = 0;
        const letterStarts = 97;
        while(sortedNumber.length) {
          let header = String.fromCharCode(letterStarts + key).toUpperCase();
          colsNumber.push({ header, data: sortedNumber.splice(0, 43) });
          colsPower.push({ header, data: sortedPower.splice(0, 43) });
          headers.push(header);
          key++;
        }
        const xlsxNumberJson = [];
        const xlsxPowerJson = [];
        colsNumber.forEach((col, i) => {
          col.data.forEach((data, j) => {
            if(!xlsxNumberJson[j]) xlsxNumberJson[j] = {};
            if(!xlsxPowerJson[j]) xlsxPowerJson[j] = {};

            xlsxNumberJson[j][col.header] = colsNumber[i].data[j].number;
            xlsxPowerJson[j][col.header] = colsPower[i].data[j].number;
          });
        })
        
        const a2zSheet = XLSX.utils.json_to_sheet(xlsxNumberJson, { header:headers, skipHeader:true });
        const powerSheet = XLSX.utils.json_to_sheet(xlsxPowerJson, { header:headers, skipHeader:true });
        /* create a new blank workbook */
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, a2zSheet, "A to Z");
        XLSX.utils.book_append_sheet(wb, powerSheet, "power");
        XLSX.writeFile(wb, `${item.balancedon}.xlsx`);
      } catch (error) {
        this.$toast.error("Error Getting Cells")
      }

    },
    close () {
      this.groupCellsDialog = false;
    },



  },
  mounted() {
    // setTimeout(() => {
    // }, 1000)
    this.initialize();
  }
};
</script>